import type { ReactElement } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import SatellitePage from "../pages/satellite/page";
import SolutionsPage from "../pages/solutions/page";
import SolutionDetailPage from "../pages/solutions/detail";
import NoticePage from "../pages/notice/page";
import NoticeDetailPage from "../pages/notice/detail";
import CareersPage from "../pages/careers/page";
import DownloadsPage from "../pages/downloads/page";
import PrivacyPage from "../pages/legal/PrivacyPage";
import TermsPage from "../pages/legal/TermsPage";

// 국문 주소. 같은 페이지가 영문으로 /en 아래에도 있습니다 (/about → /en/about, / → /en). 언어는 주소로 정해집니다(src/lib/locale.ts).
const PAGES: [string, ReactElement][] = [
  ["/", <Home />],
  ["/about", <AboutPage />],
  ["/services", <ServicesPage />],
  ["/satellite", <SatellitePage />],
  ["/solutions", <SolutionsPage />],
  ["/solutions/:slug", <SolutionDetailPage />],
  ["/notice", <NoticePage />],
  ["/notice/:id", <NoticeDetailPage />],
  ["/careers", <CareersPage />],
  ["/downloads", <DownloadsPage />],
  ["/privacy", <PrivacyPage />],
  ["/terms", <TermsPage />],
];

const routes: RouteObject[] = [
  ...PAGES.map(([path, element]) => ({ path, element })),
  ...PAGES.map(([path, element]) => ({ path: path === "/" ? "/en" : `/en${path}`, element })),
  { path: "*", element: <NotFound /> },
];

export default routes;
